import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ModalModule } from '../../components/tnk-modal/modal.module';
import { TNKUtilitiesModule } from './../../utils/utilities.module';

import { NgxImageCompressService } from 'ngx-image-compress';

import { ConfirmationFormComponent } from './confirmation-form.component';
import { ConfirmationFormService } from './confirmation-form.service';
import { ConfirmationIndexService } from './confirmation-index/confirmation-index.service';
import { ConfirmationIndexComponent } from './confirmation-index/confirmation-index.component';
import { ConfirmationWorkPlaceService } from './confirmation-work-place/confirmation-work-place.service';
import { ConfirmationSelfiePictureService } from './confirmation-selfie-picture/confirmation-selfie-picture.service';
import { ConfirmationPinPictureService } from './confirmation-pin-picture/confirmation-pin-picture.service';
import { ConfirmationWorkPlaceComponent } from './confirmation-work-place/confirmation-work-place.component';
import { ConfirmationSelfiePictureComponent } from './confirmation-selfie-picture/confirmation-selfie-picture.component';
import { ConfirmationPinPictureComponent } from './confirmation-pin-picture/confirmation-pin-picture.component';
import { ConfirmationBankAccountComponent } from './confirmation-bank-account/confirmation-bank-account.component';
import { ConfirmationConstantService } from './shared/services/confirmation.const';
import { ConfirmationGlobalService } from './shared/services/confirmation-global.service';
import { ConfirmationConfirmedComponent } from './confirmation-confirmed/confirmation-confirmed.component';

import { RegionService } from '../../services/region.service';
import { AuthTokenService } from '../../services/authToken.service';

const /** @type {?} */ components: any[] = [
  ConfirmationFormComponent,
  ConfirmationIndexComponent,
  ConfirmationBankAccountComponent,
  ConfirmationPinPictureComponent,
  ConfirmationSelfiePictureComponent,
  ConfirmationWorkPlaceComponent,
  ConfirmationConfirmedComponent,
];

const /** @type {?} */ services: any[] = [
  ConfirmationFormService,
  ConfirmationPinPictureService,
  ConfirmationSelfiePictureService,
  ConfirmationWorkPlaceService,
  ConfirmationIndexService,
  ConfirmationGlobalService,
  ConfirmationConstantService,
  NgxImageCompressService,
  RegionService,
  AuthTokenService,
];
export class TNKConfirmationFormModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [...components],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ModalModule,
    TNKUtilitiesModule,
  ],
  exports: [...components],
  providers: [...services],
  entryComponents: [],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TNKConfirmationFormModule_tsickle_Closure_declarations() {
/** @type {?} */
TNKConfirmationFormModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TNKConfirmationFormModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
